<template>
    <div class="auth-background" :class="{ 'auth-background--embed': isSiteEmbed }" data-cy="auth-layout">
        <iframe
            v-if="isSiteEmbed"
            :src="embedHeaderUrl"
            class="auth-embed auth-embed--header"
            title="Affogata header"
            scrolling="no"
            data-cy="auth-layout-embed-header"
        />

        <iframe
            v-if="isSiteEmbed"
            :src="embedIntroUrl"
            class="auth-embed auth-embed--intro"
            title="Affogata intro"
            scrolling="no"
            data-cy="auth-layout-embed-intro"
        />

        <a-row
            type="flex"
            justify="center"
            align="middle"
            class="auth-content"
            :style="{ height: isSiteEmbed ? 'auto' : '100%' }"
            data-cy="auth-layout-wrapper"
        >
            <a-col class="auth-container" data-cy="auth-layout-wrapper-col">
                <a-row type="flex" justify="center" data-cy="auth-layout-container">
                    <a-col
                        v-if="isLogoVisible"
                        :xs="24"
                        :style="{ display: 'flex', justifyContent: 'center' }"
                        class="logo-wrapper"
                        data-cy="auth-layout-container-logo-col"
                    >
                        <a
                            href="https://www.affogata.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-cy="auth-layout-logo-link"
                        >
                            <img src="@/assets/images/logo.svg" data-cy="auth-layout-logo" />
                        </a>
                    </a-col>
                    <a-col :xs="24" data-cy="auth-layout-main-col">
                        <slot />
                    </a-col>
                </a-row>
            </a-col>
        </a-row>

        <iframe
            v-if="isSiteEmbed"
            :src="embedFooterUrl"
            class="auth-embed auth-embed--footer"
            title="Affogata footer"
            scrolling="no"
            data-cy="auth-layout-embed-footer"
        />
    </div>
</template>

<script>
import isSiteEmbedSource from '@/helpers/isSiteEmbedSource';
import buildSiteEmbedUrl from '@/helpers/buildSiteEmbedUrl';

export default {
    computed: {
        embedHeaderUrl() {
            return buildSiteEmbedUrl('header', this.$route.query.source);
        },

        embedIntroUrl() {
            return buildSiteEmbedUrl('intro', this.$route.query.source);
        },

        embedFooterUrl() {
            return buildSiteEmbedUrl('footer', this.$route.query.source);
        },

        isSiteEmbed() {
            return isSiteEmbedSource(this.$route.query.source);
        },

        isLogoVisible() {
            return !this.isSiteEmbed;
        }
    }
};
</script>

<style scoped>
.auth-background {
    /* Design tokens — shared with the sandbox layout */
    --ink: #f2f6fa;
    --ink-2: #c7d2de;
    --ink-3: #9daec0;
    --line: #1b2735;
    --line-2: #233140;
    --green: #5fbf7f;
    --green-deep: #6fcf8f;
    --bg: #05080b;
    --bg-soft: #0a1016;
    --input-bg: #070b10;
    --error: #e5484d;
    --muted: #5c6b7c;
    --display: 'Work Sans', sans-serif;
    --sans: 'Open Sans', Helvetica, Arial, sans-serif;
    --mono: 'SF Mono', Menlo, Consolas, monospace;

    font-family: var(--sans);
    background: var(--bg);
    color: var(--ink-2);
    min-height: 100vh;
    padding: 40px 20px;
    -webkit-font-smoothing: antialiased;
}

.auth-background--embed {
    display: flex;
    flex-direction: column;
    padding: 0;
}

.auth-background--embed .auth-content {
    flex: 1 1 auto;
    padding: 40px 20px;
}

.auth-background--embed .auth-container {
    width: 900px;
    max-width: 100%;
}

@media (max-width: 480px) {
    .auth-background--embed .auth-content,
    .auth-background--embed .auth-container {
        width: 100%;
    }
}

.auth-embed {
    display: block;
    width: 100%;
    border: 0;
}

.auth-embed--header {
    height: 72px;
}

.auth-embed--intro {
    height: 300px;
}

.auth-embed--footer {
    height: 340px;
}
</style>
